"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _resetGlobal(globalStateManager) {
    return globalStateManager.reset();
}
exports.default = _resetGlobal;
;
